(function(){
    var $menu_toggle = $('#master-menu-logo');
    var $menu = $('#master-menu');
    var status;

    $menu_toggle.on('click', function () {
        document.cookie = 'menu_state=' + ($menu.toggleClass('open').hasClass('open') ? 'open' : 'closed');
    });

    // TODO - need to rewrite some code to clean up, untill then, a quick workaround
    $menu
        .on('click' , '.menu-header', function() {
            $menu.find('.submenu, .menu').toggleClass('closed');
        })
        .on('click', '.js-mmih', function (e) {
            // When the lower level menu href is clicked, close the menu after the reload
            document.cookie = 'menu_state=closed';
            return true;
        });

    $(document)
        .on('click', function(e) {
            if ($(e.target).closest('#master-menu, #master-menu-logo').length || !$menu.hasClass('open')) {
                // When clicking inside the menu or the menu is already closed, simply do nothing
                return;
            }

            $menu.removeClass('open');
            document.cookie = 'menu_state=closed';
        });
})();